import React, { useState } from "react";
import { Card, Input, Button, message } from "antd";
import { useSaveBankDetailsMutation } from "../../../slices/usersApiSlice";
import toast, { Toaster } from "react-hot-toast";

const BankDetailsScreen = () => {
  const [holderName, setHolderName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [ifsc, setIfsc] = useState("");

  const [saveBankDetails, { isLoading }] = useSaveBankDetailsMutation();

  const submitHandler = async () => {
    try {
      await saveBankDetails({
        holderName,
        accountNumber,
        ifsc,
      }).unwrap();

      toast.success("Bank details saved successfully");

      setHolderName("");
      setAccountNumber("");
      setIfsc("");
    } catch (err) {
      toast.error(err?.data?.error || "Failed to save bank details");
    }
  };

  return (
    <>
        <Toaster position="top-right" />

    <Card title="Add Bank Details" style={{ maxWidth: 500, margin: "auto" }}>
      <Input
        placeholder="Account Holder Name"
        value={holderName}
        onChange={(e) => setHolderName(e.target.value)}
        style={{ marginBottom: 15 }}
        />

      <Input
        placeholder="Account Number"
        value={accountNumber}
        onChange={(e) => setAccountNumber(e.target.value)}
        style={{ marginBottom: 15 }}
        />

      <Input
        placeholder="IFSC Code"
        value={ifsc}
        onChange={(e) => setIfsc(e.target.value.toUpperCase())}
        style={{ marginBottom: 20 }}
        />

      <Button
        type="primary"
        loading={isLoading}
        onClick={submitHandler}
        block
          className="gold-btn"

        >
        Save Bank Details
      </Button>
    </Card>
        </>
  );
};

export default BankDetailsScreen;